import AuditLogViewModal, {AuditLogViewModalProps} from './AuditLogViewModal';

export {AuditLogViewModalProps};
export default AuditLogViewModal;
